import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

const config = {
	apiKey: "AIzaSyBT3gcmIJDUV6sGzTGrTXqMM3XpboH28UQ",
	authDomain: "resultam-coder-01.firebaseapp.com",
	databaseURL: "https://resultam-coder-01.firebaseio.com",
	projectId: "resultam-coder-01",
	storageBucket: "resultam-coder-01.appspot.com",
	messagingSenderId: "1001106649499"
}
const app = firebase.initializeApp(config)

export const auth = app.auth()
export const db = app.database()
export const googleProvider = new firebase.auth.GoogleAuthProvider()